<!-- components/InvitationPromotion.vue -->
<template>
    <section class="invitation-promotion">
      <h4>七、邀请推广</h4>
      <div class="promotion-content">
        <p>✨ 发布社交平台（推特/ins/油管等），标题加入关键词：查人、定位、社工库</p>
        <p>✨ 评论区放置您的邀请链接：
          <a href="https://t.me/ZLSGKVIP_BOT" target="_blank">
            /start 个人信息 邀请链接
          </a>
        </p>
        <p>✨ 邀请奖励：直接邀请+3分，二级推广+1分</p>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'InvitationPromotion'
  }
  </script>
  
  <style scoped>
  .promotion-content {
    padding: 15px;
    background: #e9d5ff;
    border-radius: 8px;
  }
  .promotion-content a {
    color: #8b5cf6;
    text-decoration: underline;
  }
  </style>